export default __webpack_public_path__ + "static/media/logo.a4d08c98.png";